module.exports = __webpack_public_path__ + "static/media/Lato-Black.ffd63a8e.woff";